import { render } from "./WasteContainers.vue?vue&type=template&id=59bb3348&scoped=true"
import script from "./WasteContainers.vue?vue&type=script&lang=js"
export * from "./WasteContainers.vue?vue&type=script&lang=js"

import "./WasteContainers.vue?vue&type=style&index=0&id=59bb3348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bb3348"]])

export default __exports__